import { render, staticRenderFns } from "./SpecialExpiredPayments.vue?vue&type=template&id=7470dcf6&scoped=true"
import script from "./SpecialExpiredPayments.vue?vue&type=script&lang=js"
export * from "./SpecialExpiredPayments.vue?vue&type=script&lang=js"
import style0 from "./SpecialExpiredPayments.vue?vue&type=style&index=0&id=7470dcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7470dcf6",
  null
  
)

export default component.exports